export default function startViewTransition(callback: VoidFunction) {
  const startViewTransition = document.startViewTransition;
  if (!!startViewTransition) {
    document.startViewTransition(callback);
  } else {
    callback();
  }
}
